import axios from "axios"

console.log(process.env.REACT_APP_CHEESY_BEAN_API_BASE_URL, "REACT APP PROCESS")
export default axios.create({
    // Locally, the Winter API runs on port 3001.
    // In prod, we'll add the base URL as an env variable.
    withCredentials: true,
    baseURL: process.env.REACT_APP_CHEESY_BEAN_API_BASE_URL,
})
